// ============================
// saga/competitorAiTableSaga.js
// ============================

import { call, put, takeLatest } from "redux-saga/effects";

import {
  GENERATE_AI_TABLE_REQUEST,
  generateAiTableSuccess,
  generateAiTableFailure,
} from "../actions/competitorAiTableActions";

import { generateAiTableApi } from "../../../services/accIqService";

function* generateAiTableWorker(action) {
  try {
    const { callback, ...payload } = action.payload;

    const response = yield call(generateAiTableApi, payload);

    yield put(generateAiTableSuccess(response.data));

    if (callback) callback();
  } catch (error) {
    yield put(
      generateAiTableFailure(
        error.response?.data?.message || "Something went wrong"
      )
    );
  }
}

export default function* competitorAiTableSaga() {
  yield takeLatest(GENERATE_AI_TABLE_REQUEST, generateAiTableWorker);
}
